import { mergeClassnames } from '@heathmont/moon-core-tw';
import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import Translate from '~/client/shared/i18n/Translate';
import useGameBadge from './useGameBadge';
import Tag from '@/external/components/Tag';

type Props = { game: SingleGameFragment };

const GameBadge: FC<Props> = ({ game }) => {
  const { hasBadge, label, bgColor } = useGameBadge(game);

  if (!hasBadge) {
    return null;
  }

  return (
    <Tag
      color="text-goten"
      className={mergeClassnames('inline-flex cursor-text', bgColor)}
      size="2xs"
    >
      <Translate id={label} />
    </Tag>
  );
};

export default GameBadge;
